var _style, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangarPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9EA3A8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400,183.8c-220.6,0-400,179.4-400,400c0,17.9,14.5,32.4,32.4,32.4c8.3,0,15.9-3.2,21.6-8.3c5.7,5.1,13.3,8.3,21.6,8.3 h194.6H400h129.7h194.6c8.3,0,15.9-3.2,21.6-8.3c5.7,5.1,13.3,8.3,21.6,8.3c17.9,0,32.4-14.5,32.4-32.4 C800,363.2,620.6,183.8,400,183.8z M367.6,551.4h-64.9v-64.9h64.9V551.4z M497.3,551.4h-64.9v-64.9h64.9V551.4z M562.2,551.4 v-97.3c0-17.9-14.5-32.4-32.4-32.4H400H270.3c-17.9,0-32.4,14.5-32.4,32.4v97.3H109.9C126.1,405.6,250,291.9,400,291.9 s273.9,113.7,290.1,259.5H562.2z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 641.9,
    y: 212.4,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 641.9,
    y: 159.6,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 641.9,
    y: 106.7,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 641.9,
    y: 53.9,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 641.9,
    y: 1,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 536.2,
    y: 106.7,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 106.7,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 694.7,
    y: 106.7,
    className: "st0",
    width: 52.8,
    height: 52.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 747.6,
    y: 106.7,
    className: "st0",
    width: 52.8,
    height: 52.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangarPlus);
export default __webpack_public_path__ + "static/media/hangar-plus.c01796ddf82d058471d161851b25d065.svg";
export { ForwardRef as ReactComponent };